import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';

export const exportToExcel = (data, filename, sheetName = 'Hoja 1') => {
  // Crear un nuevo workbook
  const workbook = XLSX.utils.book_new();
  
  // Convertir los datos a formato de hoja de cálculo
  const worksheet = XLSX.utils.json_to_sheet(data);
  
  // Agregar la hoja al workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  
  // Generar el archivo y descargarlo
  XLSX.writeFile(workbook, `${filename}.xlsx`);
};

export const ExcelFileTemplate = ({ dataSet, children }) => {
  const { fileResultName, sheetName = "Hoja 1", columns } = dataSet;
  
  const handleExport = () => {
    if (columns && columns.length > 0) {
      exportToExcel(columns, fileResultName, sheetName);
    }
  };

  return React.cloneElement(children, { onClick: handleExport });
};

export const ExportExcelFile = ({ dataSet, fetchDataExcel, children }) => {
  const { fileResultName, sheetName = "Hoja 1", columns } = dataSet;
  const [clickedFromChildren, setClickedFromChildren] = useState(false);

  useEffect(() => {
    if (columns && clickedFromChildren) {
      exportToExcel(columns, fileResultName, sheetName);
      setClickedFromChildren(false);
    }
  }, [columns, clickedFromChildren, fileResultName, sheetName]);

  const handleChildButtonClick = () => {
    if (columns) {
      exportToExcel(columns, fileResultName, sheetName);
    } else {
      setClickedFromChildren(true);
      fetchDataExcel();
    }
  };

  return React.cloneElement(children, { onClick: handleChildButtonClick });
};